<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p1_html" className="web-tellent-contains-link" />&nbsp;
    <email-margin [height]="30" />
    <hr />
    <email-margin [height]="28" />
    <ng-container *mailgunIf="data.detail_1_html">
      <email-text [contents]="data.detail_1_html!" presetName="paragraph" />
    </ng-container>
    <ng-container *mailgunIf="data.detail_2_html">
      <email-text [contents]="data.detail_2_html!" presetName="paragraph" />
    </ng-container>
    <ng-container *mailgunIf="data.detail_3_html">
      <email-text [contents]="data.detail_3_html!" presetName="paragraph" />
    </ng-container>
    <ng-container *mailgunIf="data.detail_4_html">
      <email-text [contents]="data.detail_4_html!" presetName="paragraph" />
    </ng-container>
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text [contents]="data.p2_html" presetName="paragraph" className="web-rt-contains-link" />
  </ng-container>
  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
